module.exports = __webpack_public_path__ + "static/media/dialog.87061d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/instagram-promo/dialog.png
// module id = 901
// module chunks = 7